import { BiLayer } from 'react-icons/bi'

import { Box, Square } from '@chakra-ui/react'

interface FloorIconIProps {
  hasIncidents: boolean
}

export const FloorIcon = ({ hasIncidents }: FloorIconIProps) => {
  return hasIncidents ? (
    <Square bgColor='#ef5c49' borderRadius='5px' size='24px'>
      <BiLayer color='#fff' size={20} />
    </Square>
  ) : (
    <Box>
      <BiLayer color='#44546F' size={24} />
    </Box>
  )
}
